import React from 'react';
import { X, AlertCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ErrorModal = ({ show, onClose, errors = [] }) => {
  const { t } = useLanguage();
  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.7)',
        backdropFilter: 'blur(4px)',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 420,
          margin: '0 16px',
          backgroundColor: '#0a0a0a',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 0 0 1px rgba(255,255,255,0.06), 0 8px 60px rgba(255,255,255,0.08)',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '18px 20px',
            borderBottom: '1px solid rgba(255,255,255,0.06)',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <AlertCircle size={18} style={{ color: '#E8520A' }} />
            <h3 style={{ fontSize: 14, fontWeight: 700, color: '#fff', margin: 0, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t('errorModal.title')}
            </h3>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'rgba(255,255,255,0.4)',
              cursor: 'pointer',
              padding: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <X size={16} />
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '24px 20px' }}>
          <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 16, lineHeight: 1.5 }}>
            {t('errorModal.subtitle')}
          </p>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
            {errors.map((error, i) => (
              <li
                key={`err-${error.slice(0, 20)}-${i}`}
                style={{
                  display: 'flex',
                  alignItems: 'start',
                  gap: 8,
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.8)',
                  padding: '8px 12px',
                  backgroundColor: 'rgba(232, 82, 10, 0.1)',
                  border: '1px solid rgba(232, 82, 10, 0.3)',
                  borderRadius: 4,
                }}
              >
                <span style={{ color: '#E8520A', fontWeight: 'bold', fontSize: 16, lineHeight: 1 }}>•</span>
                <span>{error}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <div style={{ padding: '16px 20px', borderTop: '1px solid rgba(255,255,255,0.06)', textAlign: 'right' }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: '#E8520A',
              color: '#fff',
              border: 'none',
              padding: '10px 24px',
              fontSize: 12,
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              borderRadius: 4,
              cursor: 'pointer',
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.opacity = '0.9')}
            onMouseLeave={(e) => (e.target.style.opacity = '1')}
          >
            {t('errorModal.gotIt')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
